import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { IForceUpdateData } from 'legacy/lut/components/widgets/public/partner360/ELT/models/IForceUpdateData'

import { IPartnerGroupAdditionalInfo } from '../../../models/IPartnerGroupAdditionalInfo'

type TMakeResultPushArgs =
  | { partnerGroupData: IPartnerGroupAdditionalInfo }
  | { partnerDataRes: IWWPartners | null }
  | { showVersionsHandler: boolean }
  | { formData: TEltFormData }
  | { item: IELTData }
  | { forceUpdateData: IForceUpdateData }

interface IMakeResultData {
  partnerGroupData: IPartnerGroupAdditionalInfo
  partnerDataRes: IWWPartners | null
  showVersionsHandler: boolean
  formData: TEltFormData
  item: IELTData
  forceUpdateData: IForceUpdateData
}

export const makeFormInfo = () => ({
  data: {} as IMakeResultData,
  push(partData: TMakeResultPushArgs) {
    this.data = { ...this.data, ...partData }
  },
})
